export default __webpack_public_path__ + "static/media/NAER logo.06aaf754.png";